<div class="ai-product-entry-inner">
@if (state() !== 'missing') {
<div class="ai-product-entry-picture" aria-hidden="true">
  @if (card(); as card) {
  <a class="ai-product-entry-link" [href]="card.url" target="_blank" rel="noopener noreferrer" tabindex="-1">
    <img class="ai-product-entry-image" [src]="card.image_url" alt="" width="136" height="136" loading="lazy"
      appHandleImageError>
  </a>
  } @else {
  <span class="ai-product-entry-image is-loading"></span>
  }
</div>
}
<div class="ai-product-entry-body">
  <ng-content />
  @if (card(); as card) {
  <a class="ai-product-entry-view" [href]="card.url" target="_blank" rel="noopener noreferrer"
    [attr.aria-label]="'View ' + card.name">
    View product
    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"
      stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
      <path d="M7 17 17 7M8 7h9v9" />
    </svg>
  </a>
  }
</div>
</div>
